type AccountWithName = {
  nameOverride?: string | null;
  accountDescription?: string | null;
  name: string;
};

export const resolveAccountName = (account?: AccountWithName | null): string =>
  account?.nameOverride || account?.accountDescription || account?.name || '';
